export default __webpack_public_path__ + "static/media/AddCreditzVideo.be1e4fbe.jpg";